import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as mainMenuActions from '../../../actions/mainMenuActions';
import * as actionTypes from '../../../actions/actionTypes';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import _ from 'lodash';


class MainMenuItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.screen),
            bite: appHelper.getBiteById(this.props.bite_id),
            userBite: this.props.userBite,
            userScreen: this.props.userScreen,
            screen_status: this.props.userScreen.status,
            current_screen_id: this.props.trackingData.lesson_location,
            isEnabled: false,
            checkEnabledState: false,
            setLocale: false,
        };

        this.loadScreen = this.loadScreen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setEnabledState = this.setEnabledState.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getLocale = this.getLocale.bind(this);
    }

    componentDidMount(){
        this.setEnabledState();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userBite !== nextProps.userBite) {
            this.setState({
                userBite: Object.assign({}, nextProps.userBite),
                userScreen: Object.assign({}, nextProps.userScreen),
                screen_status: nextProps.userScreen.status,
                checkEnabledState: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.screen)
            });
        }
    }

    componentDidUpdate(){
        if(this.state.checkEnabledState){
            this.setEnabledState();
        }

        if(this.state.setLocale){
            this.getLocale();
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale), setLocale: false});
    }

    setEnabledState(){

        let isEnabled = false;
        if(!this.state.bite.show_target_screens_in_menu && this.state.bite.navigation_type === objectConstants.LINEAR) {
            isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen, this.state.userBite);
        }else if(this.state.bite.show_target_screens_in_menu && this.state.bite.navigation_type === objectConstants.LINEAR){
            //isEnabled = appHelper.checkLinearTargetScreenEnabled(this.state.userScreen, this.state.userBite, this.state.bite.screens);
            isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen, this.state.userBite);
        }else{
            isEnabled = true;
        }

        this.setState({
            checkEnabledState: false,
            isEnabled: isEnabled
        });
    }

    loadScreen() {
        if(this.state.isEnabled) {
            this.props.actions.setNewLessonLocation(this.props.screen.screen_id);
            this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
        }
    }

    setClass() {
        let className = ``;

        if(!this.state.isEnabled) {
            className += `disabled `;
        }
        if (this.props.screen.screen_id === this.state.current_screen_id) {
            className += `${objectConstants.CLASS_ACTIVE} `;
        }else if(this.state.bite.show_target_screens_in_menu){
            let currentScreen = appHelper.getArrayObjectByKey(this.state.bite.screens,"screen_id",this.state.current_screen_id);
            if(currentScreen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET){
                let currentScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.bite.screens,"screen_id",this.state.current_screen_id);
                let prevTargetScreen = appHelper.getPrevTargetScreen(currentScreenIndex, this.state.bite.screens,"screen_id");
                if(prevTargetScreen.screen_id === this.props.screen.screen_id){
                    className += `${objectConstants.CLASS_ACTIVE} `;
                }
            }
        }


        if (this.state.screen_status === objectConstants.STATUS_NOT_REQUIRED) {
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        } else if (this.state.screen_status === objectConstants.STATUS_IN_PROGRESS) {
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        } else if (this.state.screen_status === objectConstants.STATUS_COMPLETE) {
            className += `${objectConstants.CLASS_COMPLETE} `;
        } else {
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }


        return className;
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.loadScreen();
        }
    }

    render() {
        return (
            <div className={`menu-nav-item ${this.setClass()}`} onClick={this.loadScreen} onKeyDown={this.setKeyboardAccessibility} role="menuitem" tabIndex={!appHelper.isDefined(this.props.isAccessible) || (appHelper.isDefined(this.props.isAccessible) && this.props.isAccessible) ? "0" : "-1"} id={`menuNavItem_${this.props.screen.screen_id}`} dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
        );
    }

}

MainMenuItem.propTypes = {
    screen: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    bite_id: PropTypes.number.isRequired,
    screen_id: PropTypes.number.isRequired,
    userBite: PropTypes.object.isRequired,
    userScreen: PropTypes.object.isRequired,
    isAccessible: PropTypes.bool,
    //current_screen_id: PropTypes.string.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    let bite_id = appHelper.getBiteByScreenId(state.trackingData.lesson_location);
    if(!appHelper.isDefined(bite_id) || bite_id === null){
        bite_id = state.userData.bites[0].bite_id;
    }
    let screen_id = ownProps.screen.screen_id;

    let userBite = _.find(state.userData.bites, function (bites) {
        return bites.bite_id === bite_id;
    });



    let userScreen = _.find(userBite.screens, function (screen) {
        return screen.screen_id === screen_id;
    });

    let lang = state.userData.lang;
    return {
        screen: ownProps.screen,
        userData: state.userData,
        bite_id: bite_id,
        screen_id: screen_id,
        userBite: userBite,
        userScreen: userScreen,
        trackingData: state.trackingData,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, mainMenuActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainMenuItem);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/mainMenu/MainMenuItem.js
 **/